/* ============================================================================
   SNAPBANDS — Cart custom behaviour  (assets/cart-custom.js)
   ----------------------------------------------------------------------------
   Drives the unlock-rewards bar. Pure vanilla JS, no jQuery.
   Hooks into Pipeline's own cart system:
     • document 'theme:cart:change'  -> fires on every add/remove/qty change,
                                         carries e.detail.cart (the live cart)
     • 'theme:drawer:open'           -> re-sync when the drawer is opened
     • on load                       -> initial /cart.js fetch so the bar is
                                         correct before the first interaction
   ============================================================================ */
(function () {
  'use strict';

  var SEL = {
    wrap:   '[data-sb-rewards]',
    msg:    '[data-sb-rewards-msg]',
    fill:   '[data-sb-rewards-fill]',
    config: '[data-sb-rewards-config]'
  };

  function readConfig(wrap) {
    var node = wrap.querySelector(SEL.config);
    var fallback = {
      target_qty: 4,
      pre: 'Add {remaining} more to unlock your reward',
      almost: 'Almost there — add {remaining} more!',
      unlocked: '🎉 Reward unlocked!'
    };
    if (!node) return fallback;
    try {
      var cfg = JSON.parse(node.textContent.trim());
      cfg.target_qty = parseInt(cfg.target_qty, 10) || fallback.target_qty;
      return cfg;
    } catch (e) {
      return fallback;
    }
  }

  function render(wrap, itemCount) {
    var cfg     = readConfig(wrap);
    var target  = cfg.target_qty;
    var qty     = Math.max(0, parseInt(itemCount, 10) || 0);
    var remain  = Math.max(0, target - qty);
    var pct     = Math.min(100, Math.round((qty / target) * 100));

    var fill = wrap.querySelector(SEL.fill);
    var msg  = wrap.querySelector(SEL.msg);

    if (fill) fill.style.width = pct + '%';

    if (qty >= target) {
      wrap.classList.add('is-unlocked');
      if (msg) msg.innerHTML = cfg.unlocked;
    } else {
      wrap.classList.remove('is-unlocked');
      var template = (remain === 1 && cfg.almost) ? cfg.almost : cfg.pre;
      if (msg) msg.innerHTML = template.replace('{remaining}', remain);
    }
  }

  function renderAll(itemCount) {
    document.querySelectorAll(SEL.wrap).forEach(function (wrap) {
      render(wrap, itemCount);
    });
  }

  function fetchAndRender() {
    window.fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderAll(cart.item_count); })
      .catch(function () { /* leave the Liquid default in place */ });
  }

  // Pipeline fires this on every cart mutation, with the full cart object.
  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) renderAll(cart.item_count);
    else fetchAndRender();
  });

  // Safety re-sync when the drawer opens (cart may have changed elsewhere).
  document.addEventListener('theme:drawer:open', fetchAndRender, true);

  // Initial paint.
  if (document.readyState !== 'loading') fetchAndRender();
  else document.addEventListener('DOMContentLoaded', fetchAndRender);
})();

/* ============================================================================
   AMP slide-cart SUPPRESSION  (preview / testing)
   Hides AMP's slidecarthq drawer and opens Pipeline's native drawer instead,
   so you can preview the coded cart while AMP is still installed.
   Safe to keep; does nothing once AMP no longer renders.
   ============================================================================ */
(function () {
  'use strict';

  function nativeDrawer() {
    return document.querySelector('[data-drawer="drawer-cart"]');
  }
  function openNative() {
    var d = nativeDrawer();
    if (d && !d.classList.contains('drawer--visible')) {
      d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }
  function neutralize() {
    var hq = document.getElementById('slidecarthq');
    if (!hq) return;
    hq.style.display = 'none';
    var ampOpen = !!hq.querySelector('.slidecarthq-overlay.open, .slidecarthq.open');
    hq.querySelectorAll('.open').forEach(function (el) { el.classList.remove('open'); });
    if (ampOpen) {
      // release AMP's scroll lock (only if it set it), then show our drawer
      ['html', 'body'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && el.style && el.style.overflow === 'hidden') el.style.overflow = '';
      });
      openNative();
    }
  }
  function start() {
    neutralize();
    try {
      new MutationObserver(neutralize).observe(document.documentElement, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* ============================================================================
   RELIABLE "open drawer on add"  (replaces AMP's flaky 600ms SLIDECART_OPEN)
   Opens Pipeline's native drawer whenever the cart item-count INCREASES,
   i.e. on a genuine add. Fires off Pipeline's own 'theme:cart:change' event,
   so it's deterministic and independent of AMP.
   ============================================================================ */
(function () {
  'use strict';
  var lastCount = null;
  function openNative() {
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d || d.classList.contains('drawer--visible')) return;
    d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    // FIRST open from an empty cart paints the cached empty state before the
    // just-added line item is fetched. Force Pipeline to reload the line items
    // once the drawer is open (twice, to win the race regardless of timing).
    setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); }, 150);
    setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); }, 600);
  }
  document.addEventListener('theme:cart:change', function (e) {
    var c = (e && e.detail && e.detail.cart) ? e.detail.cart.item_count : null;
    if (lastCount !== null && c !== null && c > lastCount) openNative();
    if (c !== null) lastCount = c;
  });
  // baseline so the very first add is recognised as an increase
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { if (lastCount === null) lastCount = c.item_count; })
    .catch(function () {});
})();

/* ============================================================================
   UPSELLS — toggle picker (swatches or dropdown), add via cart API, refresh
   ============================================================================ */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } })); })
      .catch(function () {});
  }
  function fbButton(item) { return item ? (item.querySelector('[data-sb-upsell-toggle]') || item.querySelector('.sb-upsell__add')) : null; }

  function addVariant(id, sourceEl) {
    if (!id) return;
    var item = sourceEl.closest('[data-sb-upsell]');
    var isSwatch = sourceEl.classList && sourceEl.classList.contains('sb-upsell__swatch');
    var fb = fbButton(item);
    var fbOriginal = fb ? fb.innerHTML : '';
    if (fb) fb.disabled = true;
    window.fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (isSwatch) sourceEl.classList.add('is-added');
        if (fb) { fb.innerHTML = 'Added \u2713'; fb.classList.add('is-added'); }
        if (item) {
          var tray = item.querySelector('[data-sb-upsell-variants]');
          if (tray) tray.hidden = true;
          var toggle = item.querySelector('[data-sb-upsell-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          var sel = item.querySelector('[data-sb-upsell-select]');
          if (sel) sel.value = '';
        }
        refreshCart();
        setTimeout(function () {
          if (fb) { fb.disabled = false; fb.innerHTML = fbOriginal; fb.classList.remove('is-added'); }
          if (isSwatch) sourceEl.classList.remove('is-added');
        }, 1600);
      })
      .catch(function () { if (fb) fb.disabled = false; });
  }

  // hide/show "hide-when-in-cart" upsells (e.g. grippy pad) based on cart contents
  function applyVisibility(cart) {
    var rows = document.querySelectorAll('[data-sb-upsell-hide-when-incart]');
    if (!rows.length) return;
    var ids = (cart && cart.items) ? cart.items.map(function (i) { return i.product_id; }) : [];
    rows.forEach(function (row) {
      var pid = Number(row.getAttribute('data-sb-upsell-pid'));
      row.hidden = ids.indexOf(pid) !== -1;
    });
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) {
      applyVisibility(e.detail.cart);
    } else {
      window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); }).then(applyVisibility).catch(function () {});
    }
  });
  // initial sync on load (also covers the case where it's already in the cart)
  window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); }).then(applyVisibility).catch(function () {});

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sb-upsell-toggle]');
    if (toggle) {
      var item = toggle.closest('[data-sb-upsell]');
      var tray = item && item.querySelector('[data-sb-upsell-variants]');
      if (tray) { var willOpen = tray.hidden; tray.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); }
      return;
    }
    var add = e.target.closest('[data-sb-upsell-add]');
    if (add) { e.preventDefault(); addVariant(add.getAttribute('data-sb-upsell-add'), add); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sb-upsell-select]');
    if (sel && sel.value) addVariant(sel.value, sel);
  });
})();

/* ============================================================================
   ROBUST backdrop close — tap the dimmed area to close the cart drawer.
   Pipeline's own underlay click can fail on mobile; this capture-phase handler
   targets the underlay element directly, so it works regardless. It only fires
   when the drawer is already open and the tap is on the underlay (never on the
   add-to-cart button), so it can't interfere with opening.
   ============================================================================ */
(function () {
  'use strict';
  function maybeClose(e) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"].drawer--visible');
    if (!drawer) return;                                   // closed -> ignore (also ignores the opening tap)
    var content = drawer.querySelector('.drawer__content'); // the panel: top + items + checkout footer
    if (content && e.target && content.contains(e.target)) return; // tap inside the panel -> keep open
    if (e.target && e.target.closest &&
        e.target.closest('[data-drawer-toggle],[data-cart-toggle],.product__submit__buttons,[data-add-to-cart],[name="add"]')) return;
    drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
  }
  document.addEventListener('click', maybeClose, true);
  document.addEventListener('touchend', maybeClose, true);
})();
